module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": require("../assets/probanner.jpg"),
      "alt": "banner02"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("产品展示")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 contleft"
  }, [_c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "leftNav"
  }, [_c('ul', {
    staticClass: "list-unstyled components",
    staticStyle: {
      "min-width": "150px"
    }
  }, _vm._l((_vm.menuList), function(list, index) {
    return _c('li', [(list.children != undefined && list.children != null && list.children != '') ? _c('div', [_c('a', {
      key: index,
      staticClass: "dropdown-toggle",
      attrs: {
        "href": '#submenu' + index,
        "data-toggle": "collapse",
        "id": 'a' + index,
        "aria-expanded": "false"
      },
      on: {
        "click": function($event) {
          return _vm.changeIndex(index)
        }
      }
    }, [_vm._v(_vm._s(list.menuName))]), _vm._v(" "), _c('ul', {
      staticClass: "collapse list-unstyled",
      attrs: {
        "id": 'submenu' + index
      }
    }, _vm._l((list.children), function(sublist, subindex) {
      return _c('li', [(sublist.children != undefined && sublist.children != null && sublist.children != '') ? _c('div', [_c('a', {
        staticClass: "dropdown-toggle leftNavCur",
        attrs: {
          "href": '#childmenu' + subindex,
          "data-toggle": "collapse",
          "aria-expanded": "false"
        },
        on: {
          "click": function($event) {
            return _vm.changeIndex2(subindex)
          }
        }
      }, [_vm._v("   " + _vm._s(sublist.menuName))]), _vm._v(" "), _c('ul', {
        staticClass: "collapse list-unstyled sub",
        attrs: {
          "id": 'childmenu' + subindex
        }
      }, _vm._l((sublist.children), function(childlist, childindex) {
        return _c('li', [_c('a', {
          key: subindex,
          staticClass: "leftNavCur2 secondmenu p2",
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              return _vm.getProducts(childlist.id, childlist.menuName, 1)
            }
          }
        }, [_vm._v("      - " + _vm._s(childlist.menuName))])])
      }), 0)]) : _c('div', [_c('a', {
        key: subindex,
        staticClass: "leftNavCur2 p2",
        attrs: {
          "href": "javascript:void(0);"
        },
        on: {
          "click": function($event) {
            return _vm.getProducts(sublist.id, sublist.menuName, 1)
          }
        }
      }, [_vm._v(" - " + _vm._s(sublist.menuName))])])])
    }), 0)]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 contright"
  }, [_c('h2', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.titleName))]), _vm._v(" "), _c('div', {
    staticClass: "Article"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "90%",
      "margin": "auto"
    }
  }, _vm._l((_vm.productList), function(list, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 section-padding4"
    }, [_c('div', {
      key: index,
      staticClass: "card div1 big-box",
      staticStyle: {
        "background-color": "#F5F5F5"
      },
      on: {
        "click": function($event) {
          return _vm.toProductDetails(list)
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "card-img-top aspect-ratio-16-9",
      attrs: {
        "src": list.path,
        "alt": "",
        "title": list.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "border-top": "1px solid lightgrey"
      }
    }, [_c('p', {
      staticClass: "card-text p2",
      attrs: {
        "title": list.name
      }
    }, [_vm._v(_vm._s(list.name))])])])])
  }), 0)]), _vm._v(" "), (_vm.total != 0) ? _c('Pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-no": _vm.pageNo,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "continues": 5
    },
    on: {
      "getPageNo": _vm.getPageNo
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("产品展示")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-header"
  }, [_c('h2', {
    staticClass: "leftTitle"
  }, [_vm._v("产品展示")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a06be7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Products.vue
// module id = 301
// module chunks = 2